import { FC } from 'react';
import { PageTitle, PageLink } from '../../../rbts/layout/core';
import { View } from './components/View';

const GruposPage: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Registro grupal</PageTitle>
      <View />
    </>
  );
};

export { GruposPage };
